 import { ChatContextType } from '@trinity/chat';
import type { Context } from '../interfaces.context';

export function hasAwaitingRepSelectionPendingWorkflow(
  activeChatSession: Context.ActiveChatSession | undefined
): boolean {
  return (
    activeChatSession?.context.type === ChatContextType.Agent &&
    activeChatSession.context.metadata?.pendingFormWorkflow?.status === 'awaiting-rep-selection'
  );
}
